// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__qmjwc","messages":"Chat_messages__12BBd","dateDivider":"Chat_dateDivider__zqE3M"};